import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchFacilityRiskHeatmapData } from 'services/api';

const useHeatmapData = () => {
  const [data, setData] = useState(null);
  const [pending, setPending] = useState(true);
  const [error, setError] = useState(null);
  const mountedRef = useRef(true);
  const requestIdRef = useRef(0);

  useEffect(() => {
    mountedRef.current = true;

    return () => {
      mountedRef.current = false;
    };
  }, []);

  const fetchData = useCallback(async () => {
    const requestId = requestIdRef.current + 1;
    requestIdRef.current = requestId;
    setPending(true);
    setError(null);

    try {
      const response = await fetchFacilityRiskHeatmapData();
      if (!Array.isArray(response)) {
        throw new Error('Unexpected heatmap response shape (expected array)');
      }

      if (mountedRef.current && requestIdRef.current === requestId) {
        setData(response);
      }
    } catch (fetchError) {
      if (mountedRef.current && requestIdRef.current === requestId) {
        setData([]);
        setError(fetchError);
      }
    } finally {
      if (mountedRef.current && requestIdRef.current === requestId) {
        setPending(false);
      }
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data, pending, error, fetchData];
};

export default useHeatmapData;
